<template>
    <section class="container-fluid content-type-37 credits" v-if="hasStats">
        <div class="container">
            <div class="row">
                <div class="col-10 col-sm-8 col-lg-6 col-lg-offset-1 col-xl-5">
                    <div class="illustration-wrapper">
                        <GraphGauge :value="perc" v-if="ppCredits" :usage="true" :progress="true" :hidePerc="true" />
                        <PpCreditsManager :card="true" />
                    </div>
                </div>

                <div class="col-12 col-sm-10 col-md-9 col-lg-5">
                    <div class="content">
                        <div class="hidden-up visible-lg-up h5 title">{{$t('common.statistics_1')}}</div>
                        <ul class="stats">
                            <li class="stat">
                                <div class="name">{{$t('views.audience.sections.summary.label')}}</div>
                                <div class="value">{{formatNumber(stats.with_label || 0)}}</div>
                            </li>
                            <li class="stat">
                                <div class="name">{{$t('views.audience.sections.summary.tag')}}</div>
                                <div class="value">{{formatNumber(stats.with_tags || 0)}}</div>
                            </li>
                            <li class="stat">
                                <div class="name">{{$t('views.audience.sections.summary.owner')}}</div>
                                <div class="value">{{formatNumber(stats.with_owner || 0)}}</div>
                            </li>
                            <li class="stat" :class="[stats.with_visits > 0 ? 'clickable accent' : '']" @click="() => {stats.with_visits > 0 && openProspectsWithVisits()}">
                                <div class="name">{{$t('views.audience.sections.summary.visits')}}</div>
                                <div class="value">{{formatNumber(stats.with_visits || 0)}}</div>
                            </li>
                            <li class="stat">
                                <div class="name">{{$t('views.audience.sections.summary.contact')}}</div>
                                <div class="value">{{formatNumber(stats.with_contacts || 0)}}</div>
                            </li>
                            <li class="stat highlight clickable" @click="openProspects">
                                <div class="name">{{$t('views.audience.sections.summary.prospects')}}</div>
                                <div class="value">{{formatNumber(stats.prospects || 0)}}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapActions, mapState } from 'pinia';
    import { useAccountStore } from '@/stores/account';
    import { useApiCreditsStore } from '@/stores/apiCredits';
    import { formatNumber } from '@/utils/formatting';
    import PpCreditsManager from '@/components/elements/misc/PpCreditsManager';
    import GraphGauge from '@/components/elements/misc/GraphGauge';

    export default {
        name: "DashboardStatsSummary",
        components: {
            GraphGauge,
            PpCreditsManager
        },
        data() {
            return {
                loaded: false,
            };
        },
        computed: {
            ...mapState(useAccountStore, ['hasStats', 'stats']),
            ...mapState(useApiCreditsStore, ['ppCredits']),
            perc() {
                if (this.ppCredits) {
                    const perc = Math.round((this.ppCredits.credits_used_month / this.ppCredits.monthly_credits) * 100);
                    return perc > 100 ? 100 : perc < 1 ? 1 : perc;
                }
                return 100;
            },
        },
        methods: {
            formatNumber,
            ...mapActions(useApiCreditsStore, ['getApiCredits']),
            openProspects() {
                this.$router.push({
                    name: 'prospects',
                    query: { 
                        prospectOptions: JSON.stringify({
                            reset: true
                        })
                    }
                });
            },
            openProspectsWithVisits() {
                this.$router.push({
                    name: 'prospects',
                    query: { 
                        prospectOptions: JSON.stringify({
                            reset: true,
                            options: {
                                visits: {
                                    min: 1,
                                    max: null,
                                    custom: 'custom'
                                }
                            }
                        })
                    }
                });
            }
        },
        async mounted() {
            await this.getApiCredits();
            this.loaded = true;
        },
    }
</script>